// extracted by mini-css-extract-plugin
export default {"brandContainer":"BrandName-module__brandContainer--bddS7","collapsedInitial":"BrandName-module__collapsedInitial--ekloz"};